import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";

export interface UploadInvestmentFilePayload {
  file: File;
  type: "image" | "attachment";
  parentId: string | number;
}

export interface UploadedFile {
  id: number;
  uuid: string;
  name: string;
  url: string;
}

export const useUploadInvestmentFile = (
  options?: UseMutationOptions<UploadedFile[], Error, UploadInvestmentFilePayload>
) => {
  return useMutation<UploadedFile[], Error, UploadInvestmentFilePayload>({
    ...options,
    mutationKey: ["uploadInvestmentFile"],
    mutationFn: async (data) => {
      const formData = new FormData();
      formData.append("files", data.file);
      formData.append("type", data.type);
      formData.append("parentId", String(data.parentId));
      return axiosInstance
        .post("/files", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data);
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas przesyłania pliku.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "upload-investment-file",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
